export default __webpack_public_path__ + "static/media/avatarD5.a7aff6d9.png";